import { SaleTagIcon } from "@/components/__shared__/SaleTagIcon/SaleTagIcon.tsx";
import classNames from "classnames/bind";
import { useStandardProps } from "@/context/StandardPropsContext/StandardPropsContext";
import styles from "./SaleTag.module.scss";

const cx = classNames.bind(styles);

type SaleTagProps = {
  isDior: boolean;
};

export const SaleTag = ({ isDior }: SaleTagProps) => {
  const { flags } = useStandardProps();
  const premiumColourSelector = flags.premiumColourSelector.value === true;

  return (
    <span
      className={cx("saleTag", {
        premiumColourSelector,
      })}
      data-testid="sale-tag"
    >
      <SaleTagIcon type="stroke" isBlackOverride={isDior} />
    </span>
  );
};
